export default {
  event_comparison_table_first_column: 'Event Name',
  event_comparison_table_second_column: 'Period',
};
